import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "@/store";
import { UserTierType } from "@/constants/enums/user-tier-type.enum";

interface AuthRedirectProps {
  children: React.ReactNode;
}

// This component redirects authenticated users away from auth pages
const AuthRedirect = ({ children }: AuthRedirectProps) => {
  const { isAuthenticated, user } = useSelector(
    (state: RootState) => state.auth,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      if (user?.user_type?.id === UserTierType.Tier3) {
        navigate("/menu", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [isAuthenticated, navigate]);

  return !isAuthenticated ? <>{children}</> : null;
};

export default AuthRedirect;
